import React from 'react';
import Button from '@material-ui/core/Button';
import { ConfirmationDialog } from "../ConfirmationDialog/ConfirmationDialog";

export function ConfirmationButton({ onClick, title = 'Save',  disabled = false }) {
  const [open, setOpen] = React.useState(false);

  const openConfirmationDialog = () => {
    setOpen(true);
  };

  const closeConfirmationDialog = () => {
    setOpen(false);
  };

  const handleConfirm = () => {
    onClick();
    closeConfirmationDialog();
  };

  return (
    <div>
      <Button variant="contained" color="primary" disabled={disabled} onClick={openConfirmationDialog}>
        {title}
      </Button>
      <ConfirmationDialog isOpen={open} onClose={closeConfirmationDialog} onConfirm={handleConfirm} />
    </div>
  );
}
